import Vue from 'vue';
import ImageFile from './ImageFile';
import MyEditor from './myEditor.vue'

const MyComponents = {
    install: function () {
        Vue.component('ImageFile',ImageFile)
        Vue.component('MyEditor',MyEditor)
    }
};

export default MyComponents;
